import { render } from "./OhMyNFTHome.vue?vue&type=template&id=1c80c47e&scoped=true"
import script from "./OhMyNFTHome.vue?vue&type=script&lang=js"
export * from "./OhMyNFTHome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c80c47e"]])

export default __exports__